'use client';
import { type AnchorHTMLAttributes, type MouseEventHandler, type PropsWithChildren } from 'react';
import {
  type SegmentAttributes,
  useSegmentInteraction,
} from '../../lib/analytics/useSegmentInteraction';

type ButtonProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'onClick'>;
type SegmentAwareAnchorProps = PropsWithChildren<
  ButtonProps & {
    segmentAttributes: SegmentAttributes;
  }
>;

export function SegmentAwareAnchor({
  children,
  segmentAttributes,
  target = '_self',
  href,
  ...props
}: SegmentAwareAnchorProps) {
  const sendSegmentInteraction = useSegmentInteraction({
    eventName: 'global_nav_link_clicked',
    attributes: {
      ...segmentAttributes,
    },
  });

  const handleClick: MouseEventHandler<HTMLAnchorElement> = event => {
    event.preventDefault();
    sendSegmentInteraction(undefined, () => {
      if (href) {
        window.open(href, target);
      }
    });
  };

  return (
    <a onClick={handleClick} target={target} href={href} {...props}>
      {children}
    </a>
  );
}
